<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Portfolios List'}}</strong>
        </div>
        <div class="col-md-1">
          <download :tableId="'users'" :fileName="'portfolios-list'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-10"></div>
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-2">
          <router-link :to="'/mutual-funds/mf-portfolio/add'" class="btn btn-sm btn-success pull-right">
            <i class="fa fa-plus"></i> Add Portfolio
          </router-link>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table id="users" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='status'">{{(row['status']===0)? 'Inactive':'Active'}}</span>
                <span v-else-if="field.name==='description'" v-html="row[field.name]"></span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="(action, index) in actions"
                    v-bind:key="index+'-action-'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages>1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li
              v-for="(page, index) in pages"
              v-bind:key="index+page"
              class="page-item"
              :class="(current_page == page)? 'active':''"
            >
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../../assets/mixins/common";
export default {
  mixins: [commonMixins],
  name: "PortfolioListing",
  created() {
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    console.log(this.url.indexOf("user-activity"), this.$route.query);
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    // this.$route.query.page
    // ? (this.pageToLoad = parseInt(this.$route.query.page))
    // : (this.pageToLoad = "1")
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "mutual-funds/portfolio	",
      apiMode: true,
      company: {},
      actions: [
        {
          btnClass: "btn-primary",
          icon: "fa-edit cwhite",
          callback: this.editPortfolio,
          tooltip: "Edit portfolio"
        },
        {
          btnClass: "btn-success",
          icon: "fa-eye cwhite",
          callback: this.viewPortfolio,
          tooltip: "View portfolio"
        },
        {
          btnClass: "btn-warning",
          icon: "fa-list cwhite",
          callback: this.portfolioReport,
          tooltip: "Portfolio Report"
        }
      ],
      tableFields: [
        // {
        //   name: "id",
        //   title: "ID"
        // },
        {
          name: "name",
          title: "Portfolio"
        },
        {
          name: "description",
          title: "Desc"
        },
        {
          name: "status",
          title: "Status"
        }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  },
  methods: {
    search() {
      console.log(this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        if (this.searchParams.sectorname != "") {
          localStorage.setItem("secC", this.searchParams.sectorname);
        }
        this.fetchData(this.searchParams);
      }
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        this.reset();
      } else {
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-activity" });
      this.searchParams = {};
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data ? { _id: "" } : { _id: "" };
        http.post(this.url, params, function(error, response) {
          console.log(response);
          // if (response.responseType === "success") {
          myself.fillableData = response;
          // myself.current_page = myself.pageToLoad;
          // myself.totalPages = response.total_pages;
          // myself.prevDisabled = myself.pageToLoad == 1;
          // myself.nextDisabled = myself.current_page == myself.totalPages;
          // myself.isLoading = false;
          // // set 5 pages to show
          // console.log("current", myself.current_page);
          // let i = 5;
          // let page = myself.current_page - 2;
          // if (page <= 0) page = 1;
          // myself.pages = [];
          // while (i) {
          //   myself.pages.push(parseInt(page));
          //   if (myself.totalPages <= page) break;
          //   page++;
          //   i--;
          // }
          // console.log("PAges", myself.pages);
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    viewPortfolio(row, index, $event) {
      this.$router.push({
        name: "mfportfolio-details",
        params: { id: row._id, name: row.name, portfolio: row }
        // query: Object.assign({}, this.$route.query, { id: row.co_code })
      });
    },
    portfolioReport(row, index, $event) {
      this.$router.push({
        name: "mfportfolio-test-reports",
        params: { id: row._id, name: row.name, portfolio: row }
      });
    },
    editPortfolio(row, index, $event) {
      console.log(row, index, $event);
      http.post(this.url, { _id: row._id }, (error, response) => {
        console.log("Port", response);
        this.$router.push({
          name: "mfPortfolioAdd",
          params: { portfolio: response[0] }
          // query: Object.assign({}, this.$route.query, { id: row.co_code })
        });
        //TODO:: add company updates into our array in future
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/portfolios/listing.vue